import { Modal, ModalHeader, OverlayTrigger, Tooltip } from "react-bootstrap";
import React, { useEffect, useRef, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../Capacity/capacity.css";
import moment from "moment/moment";
import {
  createCapacityGenerator,
  getGeneratorCapacityall,
  getGeneratorPlantDetails,
  updateCapacityGenerator,
} from "../../store/Capacity/actions";
import { useDispatch, useSelector } from "react-redux";
import "../DashBoard/previewModel.css";
import CustomConfirmBox from "./customConfirmBox";
import { toast } from "react-toastify";
import { toastProperties } from "../../commons/Toast/Toaster";
import dayjs from "dayjs";
import { addHours } from "date-fns";
import capacityGeneratorService from "../../components/Services/capacityGenerator.service";
import { disableButton, enableButton } from "../../store/ButtonFlag/actions";
import CustomTimePicker from "../../components/TimePicker/customTimePicker";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import energyTypeService from "../../components/Services/energyType.service";
import {
  getSpeceficTraders,
  getSpeceficTradersNew,
} from "../../store/Analyst/action";
import TraderModal from "./TraderModal/TraderModal";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import documentUploadService, {
  tcGeneratorUpload,
} from "../../components/Services/documentUpload.service";
import UploadedDocument from "../Documents/UploadedDocument";
import { Preview, RemoveRedEye } from "@mui/icons-material";
import {
  gridcoMargin,
  gridcoMarginGenerator,
  StateCheck,
  TraderList,
} from "../../commons/TraderCheck";
import { is } from "date-fns/locale";

function isSevenDayRange(startDateStr, endDateStr) {
  // Convert input strings to Date objects
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Calculate the difference in time (milliseconds)
  const timeDiff = endDate - startDate;

  // Convert milliseconds to days
  const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

  // Return whether the difference is exactly 7 days
  return dayDiff <= 7;
}

export const PreviewModel = ({
  isOpen,
  handleSubmit,
  duplicate,
  directConnect,
}) => {
  const dispatch = useDispatch();
  let token = useSelector((state) => state?.sessionState?.token);
  let isEditCase = typeof isOpen == "object";
  const [holdBtnText, setHoldBtnText] = useState("Hold");
  const [holdOpen, setHoldOpen] = useState(false);
  const [withdrawOpen, setWithdrawOpen] = useState(false);

  const [allRegion, setAllRegions] = useState([]);
  const [allVoltage, setAllVoltage] = useState([]);

  const stateId = useSelector(
    (state) => state?.capacityReducer?.plantData?.stateUtId
  );

  const traderList = useSelector(
    (state) => state?.analystReducer?.companyTraders
  );
  const generatorPlantDetails = useSelector(
    (state) => state?.capacityReducer?.plantData || []
  );
  const isButtonEnabled = useSelector(
    (state) => state?.buttonReducer?.isButtonEnabled
  );
  const companiesList = useSelector((state) => state?.sessionState?.userList);
  const isDiscom = companiesList?.[0].companyRoles?.filter(
    (item) => item.role.role === "BANKING"
  );

  const [selectedTraders, setSelectedTraders] = useState([]);
  const [selTrader, setSelTrader] = useState("");

  const [deliveryType, setDeliveryType] = useState("");
  const [tradeModal, setTradeModal] = useState(false);
  const [popupRes, setPopRes] = useState({});

  const [fixedValue, setFixedValue] = useState(
    isOpen?.energyRateStr ? false : true
  );

  const fileInputRef = useRef(null);
  const [viewDoc, setViewDoc] = useState(isOpen?.tncDocument);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [selectedFileData, setSelectedFileData] = useState(null);
  const [isPdfOpen, setIsPdfOpen] = useState(false);

  const [docx, setdocx] = useState(false);

  useEffect(() => {
    // traders
    if (generatorPlantDetails?.company?.id) {
      getSpeceficTradersNew(generatorPlantDetails?.company?.id)(dispatch);
    }
  }, [generatorPlantDetails]);

  const initialValues = {
    installedCapValueDuringSignup: generatorPlantDetails?.installedCap,
    startDate: isEditCase ? new Date(isOpen?.dateStartAt) : "",
    startTime: isEditCase ? isOpen?.slotStartAt : "",
    endDate: isEditCase ? new Date(isOpen?.dateEndAt) : "",
    endTime: isEditCase
      ? isOpen?.slotEndAt === "23:59"
        ? "24:00"
        : isOpen?.slotEndAt
      : "",
    sellingCost: directConnect
      ? isOpen?.landingCost
      : isEditCase
      ? isOpen?.sellingCost
      : "",
    energyRateStr: isOpen?.energyRateStr || "DAM+",
    sellEnergy: directConnect
      ? isOpen?.purchaseEnergy
      : isEditCase
      ? isOpen?.sellEnergy
      : "",
    energyType: generatorPlantDetails?.energyType?.type
      ? generatorPlantDetails.energyType.type
      : "",
    pointOfIngestion: generatorPlantDetails?.poi?.value
      ? generatorPlantDetails.poi.value
      : "",
    voltageLevel: isOpen?.discomVoltageLevel
      ? isOpen?.discomVoltageLevel
      : isEditCase && generatorPlantDetails?.discomVoltage === null
      ? isOpen?.isStu
        ? generatorPlantDetails?.company?.stuVoltageLevel
        : generatorPlantDetails?.company?.istsVoltageLevel
      : generatorPlantDetails?.discomVoltage,
    notifyFavouriteConsumers: isEditCase ? isOpen?.isNotifyFav : "",
    expiryDate: isEditCase
      ? isOpen?.bidEndAt && new Date(isOpen?.bidEndAt)
      : "",
    expiryTime: isEditCase
      ? isOpen?.bidEndAt && moment(isOpen?.bidEndAt).format("HH:mm")
      : "",
    endtimes: "",
    poiVal: isEditCase
      ? !isOpen?.exBus
        ? isOpen?.isStu
          ? "stu"
          : "ists"
        : "Ex_Bus-bar"
      : "",
    regionSelect: isEditCase ? isOpen?.region : "",
    tncDocument: isEditCase ? isOpen?.tncDocument : "",
    comments: isEditCase ? isOpen?.comments : "",
    tradeconnectTncDocument: "",
    tncFixed: "",
    generalTnc: true,
    acceptanceDate: isOpen?.acceptanceDate
      ? new Date(isOpen?.acceptanceDate)
      : "",
    acceptanceTime: isOpen?.acceptanceTime || "",
  };

  useEffect(() => {
    if (isOpen) {
      let type = isOpen?.isInterstate;
      // let trader = traderList?.filter((ele) => ele?.isInterstate === type);
      // setSelectedTraders(trader);
      setSelTrader(isOpen?.traderAssigned);
      setDeliveryType(type);
    }
  }, [isOpen]);

  useEffect(() => {
    getGeneratorPlantDetails()(dispatch);
    getAllRegions();
    getAllVoltage();
  }, []);

  const getAllRegions = async () => {
    energyTypeService
      .getAllRegions()
      .then((response) => {
        if (response && response.data.code === 200) {
          setAllRegions(response?.data?.data);
        }
      })
      .catch((err) => console.log(err));
  };
  const getAllVoltage = async () => {
    energyTypeService
      .getAllVoltage()
      .then((response) => {
        if (response && response.data.code === 200) {
          setAllVoltage(response?.data?.data);
        }
      })
      .catch((err) => console.log(err));
  };

  const handleFormSubmit = (values) => {
    if (!values?.generalTnc) {
      toast.error(
        "Please Accept General Terms and Conditions",
        toastProperties
      );
    }
    let startTime = values.startTime;
    let endTime = values.endTime;
    let expiryTime = values.expiryTime;

    if (typeof startTime !== "string") {
      startTime = dayjs(startTime).format("HH:mm");
    }
    if (typeof endTime !== "string") {
      endTime = dayjs(endTime).format("HH:mm");
    }
    if (typeof expiryTime !== "string") {
      expiryTime = dayjs(expiryTime).format("HH:mm");
    }
    let reqBody = {
      id:
        duplicate || directConnect
          ? null
          : isEditCase
          ? isOpen.id && isOpen.id
          : null,
      plantId: generatorPlantDetails.id,
      name:
        duplicate || directConnect
          ? null
          : isEditCase
          ? isOpen.name && isOpen.name
          : null,
      dateStartAt: `${moment(values.startDate).format("DD-MMM-YYYY")}`,
      dateEndAt: `${moment(values.endDate).format("DD-MMM-YYYY")}`,
      slotStartAt: startTime,
      slotEndAt: endTime && endTime === "24:00" ? "23:59" : endTime,
      sellingCost: fixedValue ? values.sellingCost : 0,
      energyRateStr: !fixedValue ? values.energyRateStr : "",
      sellEnergy: values.sellEnergy,
      isNotifyFav: values.notifyFavouriteConsumers,
      region: Number(values?.regionSelect),
      bidEndAt: `${moment(values.expiryDate).format(
        "DD-MMM-YYYY"
      )} ${expiryTime}`,
      isStu: values.poiVal === "stu",
      exBus: values.poiVal === "Ex_Bus-bar",
      voltageLevel: values.voltageLevel,
      isInterstate:
        deliveryType === "false" || deliveryType === false ? false : true,
      traderAssigned: selTrader,
      tncDocument: values.tncDocument?.id,
      comments: values.comments,
      tradeconnectTncDocument: values?.tradeconnectTncDocument,
      tncFixed: "",
      margin:
        values.poiVal === "stu" &&
        isSevenDayRange(values?.startDate, values?.endDate)
          ? gridcoMarginGenerator
          : null,
      generalTnc: values?.generalTnc,
      acceptanceDate: `${moment(values?.acceptanceDate).format("DD-MMM-YYYY")}`,
      acceptanceTime: values?.acceptanceTime,
    };
    if (TraderList.includes(traderList?.[0]?.id) && values?.poiVal === "stu") {
      reqBody["traderAssigned"] = traderList?.[0]?.id;
      handleSubmitModal(reqBody);
      return;
    } else {
      reqBody["traderAssigned"] = 0;
      handleSubmitModal(reqBody);
      return;
    }

    // setPopRes(reqBody);
    // setTradeModal(true);
  };

  const handleSubmitModal = (reqBody) => {
    if (directConnect) {
      handleSubmit(reqBody);
    } else if (isEditCase && !duplicate) {
      updateCapacityGenerator({ reqBody, handleSubmit })(dispatch);
    } else {
      createCapacityGenerator({ reqBody, handleSubmit })(dispatch);
    }
  };

  const validationSchema = Yup.object().shape({
    startDate: Yup.date().required("required field"),
    startTime: Yup.string().required("required field"),
    endDate: Yup.date().required("required field"),
    endTime: Yup.string().required("required field"),
    expiryDate: Yup.date().required("required field"),
    expiryTime: Yup.string().required("required field"),
    // energyRateStr: fixedValue && Yup.string().required("required field"),
    // sellingCost:
    //   !fixedValue &&
    //   Yup.number()
    //     .test(
    //       "valueRange",
    //       `Value must be between 0 and 100 with 2 decimal places`,
    //       (value) => {
    //         if (value === undefined || value === null) {
    //           return true;
    //         }
    //         const decimal = String(value).split(".")[1];
    //         return (
    //           value >= 0 && value <= 100 && (decimal?.length <= 2 || !decimal)
    //         );
    //       }
    //     )
    //     .required("required field"),
    sellEnergy: generatorPlantDetails?.installedCap
      ? Yup.number()
          .test(
            "valueRange",
            `Value must be between 0 and ${generatorPlantDetails?.installedCap} with 3 decimal places`,
            (value) => {
              if (value === undefined || value === null) {
                return true;
              }
              const decimal = String(value).split(".")[1];
              return (
                value >= 0 &&
                value <= generatorPlantDetails?.installedCap &&
                (decimal?.length <= 3 || !decimal)
              );
            }
          )
          .required("Quantity is a required field")
          .max(
            generatorPlantDetails?.installedCap,
            "Quantity must be less than or equal to Installed Capacity given during signup"
          )
      : Yup.number()
          .test(
            "valueRange",
            `Value must be between 0 and 10000 with 3 decimal places`,
            (value) => {
              if (value === undefined || value === null) {
                return true;
              }
              const decimal = String(value).split(".")[1];
              return (
                value >= 0 &&
                value <= 10000 &&
                (decimal?.length <= 3 || !decimal)
              );
            }
          )
          .required("Quantity is a required field"),
    poiVal:
      generatorPlantDetails?.discomVoltage === null
        ? Yup.string().required("Select Poin Of Injection")
        : Yup.string().notRequired(),
  });
  const handleHold = () => {
    setHoldOpen(true);
  };

  const handleHoldClose = () => {
    disableButton()(dispatch);
    const data = {
      id: isOpen?.id,
      status: isOpen?.status === "HOLD" ? "ACTIVE" : "HOLD",
    };
    capacityGeneratorService
      .updateCapacityStatus(data)
      .then((response) => {
        if (response?.data?.code === 200) {
          setHoldOpen(false);
          handleSubmit();
          getGeneratorCapacityall()(dispatch);
          toast.success("Status updated successfully", toastProperties);
          enableButton()(dispatch);
        } else if (response?.data?.code !== 200) {
          enableButton()(dispatch);
        }
      })
      .catch((error) => {
        console.error("Api call Error :", error);
        enableButton()(dispatch);
      });
  };
  const handleCloseNo = () => {
    setHoldOpen(false);
  };

  const handleWithdraw = () => {
    setWithdrawOpen(true);
  };
  const handleWithdrawClose = () => {
    disableButton()(dispatch);
    const data = {
      id: isOpen?.id,
      status: "WITHDRAWN",
    };
    capacityGeneratorService
      .updateCapacityStatus(data)
      .then((response) => {
        if (response?.data?.code === 200) {
          setWithdrawOpen(false);
          handleSubmit();
          getGeneratorCapacityall()(dispatch);
          enableButton()(dispatch);
          toast.success(
            "This capacity has been withdrawn successfully",
            toastProperties
          );
        } else if (response?.data?.code !== 200) {
          enableButton()(dispatch);
        }
      })
      .catch((error) => {
        console.error("Api call Error :", error);
        enableButton()(dispatch);
      });
  };
  const handleWithdrawCloseNo = () => {
    setWithdrawOpen(false);
  };
  const numberInputOnWheelPreventChange = (e) => {
    e.target.blur();

    // Prevent the page/container scrolling
    e.stopPropagation();

    // Refocus immediately, on the next tick (after the current function is done)
    setTimeout(() => {
      e.target.focus();
    }, 0);
  };

  const handleSelectTrader = (value) => {
    setDeliveryType(value);
    let check = value === "true" ? true : false;
    let trader = traderList?.filter((ele) => ele?.isInterstate === check);
    setSelectedTraders(trader);
  };

  const handleSelEachTrader = (value) => {
    setSelTrader(value);
  };

  const handleUploadTC = (e, setFieldValue, key, type) => {
    const fun = async (e) => {
      const fileList = e?.target?.files;
      if (fileList.length > 0) {
        const file = fileList[0];
        let extension = file.name.split(".").pop();
        let fileSize = file.size / 1024 / 1024;
        let extList = ["pdf"];
        if (fileSize < 10) {
          if (extList.includes(extension)) {
            let formData = new FormData();
            formData.append("file", file);
            const config = {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            };
            let data = (
              await documentUploadService.documentUpload(type, formData, config)
            )?.data;
            if (data?.data) {
              setFieldValue(key, data?.data || "");
              let tcData = await tcGeneratorUpload(fileList, "TERMS", token);
              console.debug(tcData);
              setFieldValue("tradeconnectTncDocument", tcData);
              toast.success("Uploaded Successfully", toastProperties);
            } else {
              fileInputRef.current.value = null;
              toast.error("Failed to upload File", toastProperties);
              setFieldValue(key, "");
            }
          } else {
            fileInputRef.current.value = null;
            setFieldValue(key, "");
            toast.error("Only Pdf formats can be uploaded", toastProperties);
          }
        } else {
          fileInputRef.current.value = null;
          toast.error("File Size Cannot Exceed 10mb", toastProperties);
          setFieldValue(key, "");
        }
      } else {
        setFieldValue(key, "");
        fileInputRef.current.value = null;
      }
    };
    fun(e);
    setViewDoc(false);
  };

  const handleViewFile = (id) => {
    getDocDataById(id, true);
  };

  const getDocDataById = (id, viewFile) => {
    documentUploadService
      .getDocumentById(id)
      .then((response) => {
        if (response?.data?.code === 200) {
          if (viewFile) {
            let fileTypeSplit = response?.data?.data?.fileName.split(".");
            setSelectedFiles(fileTypeSplit[fileTypeSplit?.length - 1]);
            setSelectedFileData(response?.data?.data?.fileInBytes);
            setIsPdfOpen(true);
          }
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };

  const handleClosePDFModal = () => {
    setIsPdfOpen(false);
  };

  const handleViewTnC = async (data) => {
    if (
      !generatorPlantDetails?.id ||
      !data?.startDate ||
      !data?.endDate ||
      !data?.startTime ||
      !data?.endTime ||
      !data?.poiVal
    ) {
      ErrorMessage("Some fields are missing. Please fill all required fields.");
      return;
    }
    let payload = {
      plantId: generatorPlantDetails?.id,
      contractDescription: "",
      dateStartAt: moment(data?.startDate).format("DD-MMM-YYYY"),
      dateEndAt: moment(data?.endDate).format("DD-MMM-YYYY"),
      slotStartAt: data?.startTime,
      slotEndAt: data?.endTime,
      price: data?.sellingCost || data?.energyRateStr,
      purchaseEnergy: data?.sellingCost || data?.energyRateStr,
      margin: gridcoMarginGenerator,
      deliveryPoint: data?.pointOfIngestion,
    };
    let res = await documentUploadService.fixedTnCGenerator(payload);
    if (res?.data?.code === 200) {
      let fileTypeSplit = res?.data?.data?.fileInBytes?.split(".");
      setSelectedFiles(fileTypeSplit[fileTypeSplit?.length - 1]);
      setSelectedFileData(res?.data?.data?.fileInBytes);
      setIsPdfOpen(true);
      setdocx(true);
    } else {
    }
  };

  return (
    <>
      {isPdfOpen && (
        <UploadedDocument
          fileData={selectedFileData}
          handleCloseModal={handleClosePDFModal}
          fileType={selectedFiles}
          isOpen={isPdfOpen}
          download={true}
          docx={docx}
        />
      )}

      {tradeModal && (
        <TraderModal
          open={tradeModal}
          handleClose={() => setTradeModal(false)}
          traderList={traderList}
          trader={selTrader}
          handleSubmit={handleSubmitModal}
          allResPonse={popupRes}
        />
      )}
      <Modal
        show={Boolean(isOpen)}
        onHide={() => handleSubmit("")}
        // aria-labelledby="ModalHeader"
        className="modal"
        size="xl"
      >
        <ModalHeader closeButton>
          <Modal.Title>
            {directConnect
              ? "Verify"
              : duplicate
              ? "Duplicate"
              : isEditCase
              ? "Edit"
              : "Add"}
            {" Listing"}
          </Modal.Title>
        </ModalHeader>
        <div className="container-fluid">
          <div className="row m-4">
            <div className="col-md-12">
              <div>
                <Formik
                  enableReinitialize
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={handleFormSubmit}
                  validateOnMount={false}
                  validate={(values) => {
                    const errors = {};
                    const currentDateTime = new Date();
                    const maxStartTime = addHours(currentDateTime, 0.5);
                    let selectedStartTime = values.startTime;
                    const minExpiryTime = addHours(currentDateTime, 0.5);
                    let selectedTExpiryTime = values.expiryTime;
                    if (typeof selectedTExpiryTime === "string") {
                      selectedTExpiryTime = dayjs(new Date())
                        .set(
                          "hour",
                          parseInt(selectedTExpiryTime.split(":")[0])
                        )
                        .set(
                          "minute",
                          parseInt(selectedTExpiryTime.split(":")[1])
                        );
                    }
                    if (typeof selectedStartTime === "string") {
                      selectedStartTime = dayjs(new Date())
                        .set("hour", parseInt(selectedStartTime.split(":")[0]))
                        .set(
                          "minute",
                          parseInt(selectedStartTime.split(":")[1])
                        );
                    }
                    let startTimeValue = values.startTime;
                    let endTimeValue = values.endTime;
                    if (typeof startTimeValue === "string") {
                      startTimeValue = dayjs(new Date())
                        .set("hour", parseInt(startTimeValue.split(":")[0]))
                        .set("minute", parseInt(startTimeValue.split(":")[1]));
                    }
                    if (typeof endTimeValue === "string") {
                      endTimeValue = dayjs(new Date())
                        .set("hour", parseInt(endTimeValue.split(":")[0]))
                        .set("minute", parseInt(endTimeValue.split(":")[1]));
                    }
                    const minEndTime = startTimeValue.add(15, "minute");

                    if (endTimeValue.isBefore(minEndTime)) {
                      errors.endTime =
                        "End time must be at least 15 minutes after start time.";
                    }

                    const validateTime = (time, field) => {
                      if (time) {
                        const timeSplit = time.split(":");
                        const minutesArr = ["00", "15", "30", "45"];
                        if (!minutesArr.includes(timeSplit[1])) {
                          errors[field] =
                            "Time should be in 15-minute intervals only";
                        }
                      }
                    };

                    validateTime(values?.startTime, "startTime");
                    validateTime(values?.endTime, "endTime");
                    validateTime(values?.expiryTime, "expiryTime");

                    if (
                      values.startDate &&
                      values.startDate.toDateString() ===
                        currentDateTime.toDateString() &&
                      selectedStartTime.isBefore(maxStartTime)
                    ) {
                      errors.startTime =
                        "Start time must be at least 30 minute from the current time.";
                    }
                    if (
                      !isEditCase &&
                      values.expiryDate &&
                      values.expiryDate.toDateString() ===
                        currentDateTime.toDateString() &&
                      selectedTExpiryTime.isBefore(minExpiryTime)
                    ) {
                      errors.expiryTime =
                        "Expiry time must be at least 30 minutes from the current time.";
                    }
                    if (
                      duplicate &&
                      values.expiryDate &&
                      values.expiryDate.toDateString() ===
                        currentDateTime.toDateString() &&
                      selectedTExpiryTime.isBefore(minExpiryTime)
                    ) {
                      errors.expiryTime =
                        "Expiry time must be at least 30 minutes from the current time.";
                    }
                    if (
                      values.startDate &&
                      values.startDate instanceof Date &&
                      values.startTime &&
                      values.expiryDate &&
                      values.expiryTime
                    ) {
                      const startDateTime = moment(
                        `${moment(values.startDate).format("DD-MMM-YYYY")} ${
                          values.startTime
                        }`,
                        "DD-MMM-YYYY HH:mm"
                      );

                      const expiryDateTime = moment(
                        `${moment(values.expiryDate).format("DD-MMM-YYYY")} ${
                          values.expiryTime
                        }`,
                        "DD-MMM-YYYY HH:mm"
                      );

                      const minExpiryDateTime = moment(startDateTime).subtract(
                        0.5,
                        "hours"
                      );
                      if (expiryDateTime.isAfter(minExpiryDateTime)) {
                        errors.expiryTime =
                          "Expiry date and time must be at least 30 minute before the start date and time.";
                      }
                    }
                    if (values?.poiVal === "") {
                      errors.poiVal = "Point of Injection Required";
                    }
                    return errors;
                  }}
                >
                  {({
                    isSubmitting,
                    setFieldTouched,
                    setFieldValue,
                    values,
                    handleBlur,
                    errors,
                  }) => {
                    let startTimeValue = values.startTime;
                    if (typeof startTimeValue == "string") {
                      startTimeValue = dayjs(new Date())
                        .set("hour", parseInt(startTimeValue.split(":")[0]))
                        .set("minute", parseInt(startTimeValue.split(":")[1]));
                    }
                    console.log("formvalues_previewModal==>", {
                      values,
                      errors,
                    });
                    return (
                      <Form>
                        <div className="row justify-contnet-center align-items-center ">
                          <div className="col-md-12">
                            <div className="">
                              <div className="row mb-3">
                                <div className="col-md-6">
                                  <div className="row">
                                    <div className="col-md-6 mb-2 mb-md-0">
                                      <label>Start Date</label>
                                      <DatePicker
                                        className="custom-input w-100"
                                        name="startDate"
                                        selected={values.startDate}
                                        onChange={(date) =>
                                          setFieldValue("startDate", date)
                                        }
                                        minDate={
                                          isEditCase
                                            ? values.expiryDate
                                            : moment().toDate()
                                        }
                                        maxDate={values.endDate}
                                        onBlur={handleBlur("startDate")}
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="Date*"
                                        autoComplete="off"
                                        showMonthDropdown
                                        scrollableMonthYearDropdown
                                        showYearDropdown
                                      />
                                      <ErrorMessage
                                        name="startDate"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                    <div className="col-md-6 mb-2 mb-md-0">
                                      <label>End Date</label>
                                      <DatePicker
                                        className="custom-input w-100"
                                        name="endDate"
                                        selected={values.endDate}
                                        onChange={(date) =>
                                          setFieldValue("endDate", date)
                                        }
                                        minDate={
                                          values.startDate
                                            ? values.startDate
                                            : moment().toDate()
                                        }
                                        onBlur={handleBlur("endDate")}
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="Date*"
                                        autoComplete="off"
                                        showYearDropdown
                                        showMonthDropdown
                                        scrollableMonthYearDropdown
                                      />
                                      <ErrorMessage
                                        name="endDate"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="row">
                                    <div className="col-md-6 mb-2 mb-md-0 minutesStep">
                                      <label>
                                        Start Time &nbsp;
                                        <OverlayTrigger
                                          placement="right"
                                          overlay={
                                            <Tooltip>
                                              Start time must be at least 3
                                              hours from the current time.
                                            </Tooltip>
                                          }
                                        >
                                          <InfoOutlinedIcon />
                                        </OverlayTrigger>
                                      </label>
                                      <CustomTimePicker
                                        minutesStep={15}
                                        updateTimeToParent={(timeText) => {
                                          setFieldValue("startTime", timeText);
                                        }}
                                        time={values.startTime}
                                        maxHours={24}
                                        hasInititalValues={isEditCase}
                                      />
                                      <ErrorMessage
                                        name="startTime"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                    <div className="col-md-6 mb-2 mb-md-0 minutes-step-15">
                                      <label>End Time</label>
                                      <CustomTimePicker
                                        minutesStep={15}
                                        updateTimeToParent={(timeText) => {
                                          setFieldValue("endTime", timeText);
                                        }}
                                        time={values.endTime}
                                        minTime={values.startTime}
                                        minTimeDiffInMinutes={15}
                                        maxHours={25}
                                        hasInititalValues={isEditCase}
                                      />
                                      <ErrorMessage
                                        name="endTime"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <hr className="horizontal-line" />
                              <div className="row mt-3">
                                <div
                                  onClick={() => setFixedValue(!fixedValue)}
                                  style={{ display: "flex", gap: "8px" }}
                                >
                                  {fixedValue ? (
                                    <CheckBoxIcon
                                      style={{
                                        fontSize: "16px",
                                        color: "orange",
                                      }}
                                    />
                                  ) : (
                                    <CheckBoxOutlineBlankIcon
                                      style={{
                                        fontSize: "16px",
                                      }}
                                    />
                                  )}
                                  <label>Fixed Rate</label>
                                </div>
                                <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                  <label
                                    htmlFor="energyType"
                                    className="postion-label-dynamic"
                                  >
                                    Energy Rate (₹ per Unit)*
                                  </label>
                                  {fixedValue ? (
                                    <Field
                                      type="number"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      placeholder="Eg. 3.5"
                                      name="sellingCost"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "-" ||
                                          e.key === "+" ||
                                          e.key === "e" ||
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  ) : (
                                    <Field
                                      type="text"
                                      onWheel={numberInputOnWheelPreventChange}
                                      className="custom-input no-spinner"
                                      placeholder="Eg. DAM + 2"
                                      name="energyRateStr"
                                      onKeyDown={(e) => {
                                        if (
                                          e.key === "ArrowUp" ||
                                          e.key === "ArrowDown"
                                        ) {
                                          e.preventDefault();
                                        }
                                      }}
                                    />
                                  )}
                                  <ErrorMessage
                                    name={
                                      fixedValue
                                        ? "sellingCost"
                                        : "energyRateStr"
                                    }
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>
                                <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                  <label
                                    htmlFor="energyType"
                                    className="postion-label-dynamic"
                                  >
                                    Quantity (MW)*
                                  </label>
                                  <Field
                                    type="number"
                                    onWheel={numberInputOnWheelPreventChange}
                                    className="custom-input no-spinner"
                                    placeholder=""
                                    name="sellEnergy"
                                    onKeyDown={(e) => {
                                      if (
                                        e.key === "-" ||
                                        e.key === "+" ||
                                        e.key === "e" ||
                                        e.key === "ArrowUp" ||
                                        e.key === "ArrowDown"
                                      ) {
                                        e.preventDefault();
                                      }
                                    }}
                                  />
                                  <ErrorMessage
                                    name="sellEnergy"
                                    component="div"
                                    className="text-danger"
                                  />
                                </div>
                                <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                  <label
                                    htmlFor="energyType"
                                    className="postion-label-dynamic"
                                  >
                                    Energy Type
                                  </label>
                                  <Field
                                    type="text"
                                    className="custom-input"
                                    placeholder="Solar*"
                                    name="energyType"
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="row mt-3">
                                <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                  {generatorPlantDetails?.discomVoltage ===
                                  null ? (
                                    <>
                                      <div className="mb-3 fw-medium">
                                        Point of Injection*
                                      </div>
                                      <div className="d-flex gap-3">
                                        <div className="form-check-flex">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="poiVal"
                                            value="ists"
                                            id="poiVal1"
                                            checked={"ists" == values.poiVal}
                                            onClick={() => {
                                              setFieldValue(
                                                "voltageLevel",
                                                generatorPlantDetails?.company
                                                  ?.istsVoltageLevel ||
                                                  allVoltage?.[0]?.level
                                              );
                                              handleSelectTrader(true);
                                            }}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="poiVal1"
                                          >
                                            ISTS
                                          </label>
                                        </div>
                                        <div className="form-check-flex">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="poiVal"
                                            value="stu"
                                            id="poiVal2"
                                            checked={"stu" == values.poiVal}
                                            onClick={() => {
                                              setFieldValue(
                                                "voltageLevel",
                                                generatorPlantDetails?.company
                                                  ?.stuVoltageLevel ||
                                                  allVoltage?.[0]?.level
                                              );
                                              handleSelectTrader(false);
                                            }}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="poiVal2"
                                          >
                                            STU
                                          </label>
                                        </div>
                                        <div className="form-check-flex">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="poiVal"
                                            value="Ex_Bus-bar"
                                            id="poiVal2"
                                            checked={
                                              "Ex_Bus-bar" == values.poiVal
                                            }
                                            onClick={() =>
                                              setFieldValue(
                                                "voltageLevel",
                                                generatorPlantDetails?.company
                                                  ?.stuVoltageLevel ||
                                                  allVoltage?.[0]?.level
                                              )
                                            }
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="poiVal2"
                                          >
                                            Ex Bus-bar
                                          </label>
                                        </div>
                                      </div>
                                      <ErrorMessage
                                        name="poiVal"
                                        className="text-danger"
                                        component="div"
                                      />
                                    </>
                                  ) : (
                                    <>
                                      <div className="mb-3 fw-medium">
                                        Point of Injection*{" "}
                                        {StateCheck.includes(stateId) &&
                                          values.poiVal == "stu" && (
                                            <div className="t_cMain">
                                              <div className="fw-medium">
                                                System Terms and Conditions
                                              </div>
                                              <div
                                                onClick={() =>
                                                  handleViewTnC(values)
                                                }
                                                className="tc_viewButton"
                                              >
                                                View
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                      <div className="d-flex gap-3">
                                        <div className="form-check-flex">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="poiVal"
                                            value="ists"
                                            id="poiVal1"
                                            checked={"ists" == values.poiVal}
                                            onClick={() => {
                                              setFieldValue(
                                                "voltageLevel",
                                                generatorPlantDetails?.company
                                                  ?.istsVoltageLevel ||
                                                  allVoltage?.[0]?.level
                                              );
                                              handleSelectTrader(true);
                                            }}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="poiVal1"
                                          >
                                            ISTS
                                          </label>
                                        </div>
                                        <div className="form-check-flex">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="poiVal"
                                            value="stu"
                                            id="poiVal2"
                                            checked={"stu" == values.poiVal}
                                            onClick={() => {
                                              setFieldValue(
                                                "voltageLevel",
                                                generatorPlantDetails?.company
                                                  ?.stuVoltageLevel ||
                                                  allVoltage?.[0]?.level
                                              );
                                              handleSelectTrader(false);
                                            }}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="poiVal2"
                                          >
                                            STU
                                          </label>
                                        </div>
                                        <div className="form-check-flex">
                                          <Field
                                            className="form-check-input"
                                            type="radio"
                                            name="poiVal"
                                            value="Ex_Bus-bar"
                                            id="poiVal2"
                                            checked={
                                              "Ex_Bus-bar" == values.poiVal
                                            }
                                            onClick={() => {
                                              setFieldValue(
                                                "voltageLevel",
                                                generatorPlantDetails?.company
                                                  ?.stuVoltageLevel ||
                                                  allVoltage?.[0]?.level
                                              );
                                            }}
                                          />
                                          <label
                                            className="form-check-label"
                                            htmlFor="poiVal2"
                                          >
                                            Ex Bus-bar
                                          </label>
                                        </div>
                                      </div>
                                      <ErrorMessage
                                        name="poiVal"
                                        className="text-danger"
                                        component="div"
                                      />
                                    </>
                                    // <>
                                    //   <label
                                    //     htmlFor="pointOfIngestion"
                                    //     className="postion-label-dynamic"
                                    //   >
                                    //     Point of Injection
                                    //   </label>
                                    //   <Field
                                    //     type="text"
                                    //     className="custom-input"
                                    //     placeholder="STU"
                                    //     name="pointOfIngestion"
                                    //     disabled
                                    //   />
                                    // </>
                                  )}
                                </div>
                                <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                  {values.poiVal === "ists" && (
                                    <Field
                                      as="select"
                                      name="regionSelect"
                                      id="regionSelect"
                                      className="custom-input"
                                    >
                                      <option value="">Select Region</option>
                                      {allRegion.map((item) => (
                                        <option key={item?.id} value={item?.id}>
                                          {item?.name}
                                        </option>
                                      ))}
                                    </Field>
                                  )}
                                </div>
                                <div className="col-md-4 mb-2 mb-md-0 position-relative">
                                  <Field
                                    as="select"
                                    name="voltageLevel"
                                    id="voltageLevel"
                                    className="custom-input"
                                  >
                                    <option value="">
                                      Select Voltage Level
                                    </option>
                                    {allVoltage.map((item) => (
                                      <option
                                        key={item?.id}
                                        value={item?.level}
                                      >
                                        {item?.level}
                                      </option>
                                    ))}
                                  </Field>
                                </div>
                              </div>
                              <hr className="horizontal-line mt-3" />
                              <div
                                className="row mb-3"
                                style={{ display: "flex" }}
                              >
                                <div className="col-md-3">
                                  <span>Delivery Type*</span>
                                  <div>
                                    <Field
                                      as="select"
                                      value={deliveryType}
                                      name=""
                                      id=""
                                      className="custom-input"
                                      onChange={(e) =>
                                        handleSelectTrader(e.target.value)
                                      }
                                    >
                                      <option value="">Select Type</option>
                                      {values.poiVal === "Ex_Bus-bar" && (
                                        <>
                                          <option key={"-101"} value={false}>
                                            Intra State
                                          </option>
                                          <option key={"-101"} value={true}>
                                            Inter State
                                          </option>
                                        </>
                                      )}
                                      {values.poiVal === "stu" && (
                                        <option key={"-101"} value={false}>
                                          Intra State
                                        </option>
                                      )}
                                      {values.poiVal === "ists" && (
                                        <option key={"-101"} value={true}>
                                          Inter State
                                        </option>
                                      )}
                                    </Field>
                                    <ErrorMessage
                                      name="deliveryType"
                                      component="div"
                                      className="text-danger"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-3 row">
                                  <div className="col-md-12 mb-2 mb-md-0">
                                    <div className="d-flex gap-2">
                                      <label
                                        className="form-check-label"
                                        htmlFor="TENDER"
                                      >
                                        {StateCheck.includes(stateId) &&
                                          values.poiVal == "stu" &&
                                          "General"}{" "}
                                        Terms and Conditions
                                      </label>
                                      {(viewDoc || values?.tncDocument) &&
                                        isSevenDayRange(
                                          values?.startDate,
                                          values?.endDate
                                        ) && (
                                          <div
                                            className="pointer-event mb-1"
                                            onClick={() =>
                                              handleViewFile(
                                                viewDoc ||
                                                  values?.tncDocument?.id
                                              )
                                            }
                                          >
                                            <OverlayTrigger
                                              placement="right"
                                              overlay={
                                                <Tooltip>Preview</Tooltip>
                                              }
                                            >
                                              <Preview color="warning" />
                                            </OverlayTrigger>
                                          </div>
                                        )}
                                    </div>
                                    <div className="file-input-wrapper">
                                      <>
                                        <input
                                          type="file"
                                          id="file-input3"
                                          className="file-input"
                                          onChange={(e) =>
                                            handleUploadTC(
                                              e,
                                              setFieldValue,
                                              "tncDocument",
                                              "CAP_GEN_TNC"
                                            )
                                          }
                                          ref={fileInputRef}
                                        />
                                        <span>
                                          {values?.tncDocument?.fileName ||
                                            "T&C"}
                                        </span>
                                        <label
                                          htmlFor="file-input3"
                                          className="file-input-label"
                                        >
                                          Browse
                                        </label>
                                      </>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div>
                                    Expiry Date/Time &nbsp;
                                    <OverlayTrigger
                                      placement="right"
                                      overlay={
                                        <Tooltip>
                                          Expiry date and time must be at least
                                          2 hours before the start date and
                                          time.
                                        </Tooltip>
                                      }
                                    >
                                      <InfoOutlinedIcon />
                                    </OverlayTrigger>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-6 mb-2 mb-md-0">
                                      <DatePicker
                                        className="custom-input w-100"
                                        name="expiryDate"
                                        selected={values.expiryDate}
                                        onChange={(date) => {
                                          setFieldValue("expiryDate", date);
                                          setFieldValue("acceptanceDate", date);
                                        }}
                                        minDate={moment().toDate()}
                                        onBlur={handleBlur("expiryDate")}
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="Date*"
                                        autoComplete="off"
                                        showYearDropdown
                                        showMonthDropdown
                                        scrollableMonthYearDropdown
                                        disabled={
                                          isEditCase &&
                                          !(duplicate || directConnect)
                                        }
                                      />
                                      <ErrorMessage
                                        name="expiryDate"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                    <div className="col-md-6 mb-2 mb-md-0 minutes-step-15">
                                      <CustomTimePicker
                                        minutesStep={15}
                                        updateTimeToParent={(timeText) => {
                                          setFieldValue("expiryTime", timeText);
                                          setFieldValue(
                                            "acceptanceTime",
                                            timeText
                                          );
                                        }}
                                        time={values.expiryTime}
                                        readOnly={
                                          isEditCase &&
                                          !(duplicate || directConnect)
                                        }
                                        maxHours={24}
                                        hasInititalValues={isEditCase}
                                      />
                                      <ErrorMessage
                                        name="expiryTime"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                  </div>
                                  <small>
                                    *Expiry date/time cannot be edited once the
                                    capacity is created
                                  </small>
                                </div>
                              </div>
                              <div className="row col-md-12">
                                <div className="col-md-6">
                                  <div>
                                    Terms Date/Time &nbsp;
                                    <OverlayTrigger
                                      placement="right"
                                      overlay={
                                        <Tooltip>
                                          Terms Expiry date and time must be at
                                          least 3 hours before the start date
                                          and time.
                                        </Tooltip>
                                      }
                                    >
                                      <InfoOutlinedIcon />
                                    </OverlayTrigger>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-6 mb-2 mb-md-0">
                                      <DatePicker
                                        className="custom-input w-100"
                                        name="acceptanceDate"
                                        selected={values?.acceptanceDate}
                                        onChange={(date) => {
                                          setFieldValue("acceptanceDate", date);
                                        }}
                                        minDate={moment().toDate()}
                                        onBlur={handleBlur("acceptanceDate")}
                                        dateFormat="dd-MMM-yyyy"
                                        placeholderText="Date*"
                                        autoComplete="off"
                                        showYearDropdown
                                        showMonthDropdown
                                        scrollableMonthYearDropdown
                                        disabled={isEditCase && !duplicate}
                                      />
                                      <ErrorMessage
                                        name="acceptanceDate"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                    <div className="col-md-6 mb-2 mb-md-0">
                                      <CustomTimePicker
                                        minutesStep={15}
                                        updateTimeToParent={(timeText) => {
                                          setFieldValue(
                                            "acceptanceTime",
                                            timeText
                                          );
                                        }}
                                        time={
                                          values?.acceptanceTime ||
                                          values?.expiryTime
                                        }
                                        readOnly={directConnect}
                                        maxHours={24}
                                        hasInititalValues={isEditCase}
                                      />
                                      <ErrorMessage
                                        name="acceptanceTime"
                                        component="div"
                                        className="text-danger"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <div className="col-md-6 ">
                                  <label htmlFor="comments">Comments</label>
                                  <Field
                                    type="text"
                                    className="custom-input no-spinner"
                                    placeholder=""
                                    name="comments"
                                    value={values.comments}
                                    max="250"
                                  />
                                </div>
                              </div>
                              <div style={{ marginTop: "16px" }}>
                                {directConnect && values?.tncDocument && (
                                  <div
                                    style={{
                                      display: "flex",
                                      gap: "16px",
                                      alignItems: "center",
                                    }}
                                  >
                                    {values?.generalTnc ? (
                                      <CheckBoxIcon
                                        style={{
                                          fontSize: "16px",
                                          color: "orange",
                                        }}
                                        onClick={() =>
                                          setFieldValue("generalTnc", false)
                                        }
                                      />
                                    ) : (
                                      <CheckBoxOutlineBlankIcon
                                        style={{
                                          fontSize: "16px",
                                          color: "orange",
                                        }}
                                        onClick={() =>
                                          setFieldValue("generalTnc", true)
                                        }
                                      />
                                    )}
                                    <div>
                                      Accept General Terms and Conditions
                                    </div>
                                  </div>
                                )}
                              </div>
                              <hr className="horizontal-line my-4" />

                              <div className="">
                                <div className="button-alignment-class">
                                  <div className="button-alignment-class-end">
                                    <button
                                      type="submit"
                                      className="btn btn-signup btn btn-primary"
                                      disabled={isButtonEnabled}
                                    >
                                      {directConnect
                                        ? "Connect"
                                        : duplicate
                                        ? "Duplicate"
                                        : isEditCase
                                        ? "Update"
                                        : "Submit"}
                                    </button>
                                  </div>
                                  {isEditCase &&
                                    !duplicate &&
                                    !directConnect && (
                                      <div
                                        style={{ display: "flex", gap: "10px" }}
                                      >
                                        <button
                                          className="btn btn-login"
                                          type="button"
                                          onClick={handleHold}
                                        >
                                          {isOpen?.status === "HOLD"
                                            ? "Release"
                                            : "Hold"}
                                        </button>
                                        {holdOpen && (
                                          <CustomConfirmBox
                                            title={
                                              isOpen?.status === "HOLD"
                                                ? "Release"
                                                : "Hold"
                                            }
                                            message={`Do you want to ${
                                              isOpen?.status === "HOLD"
                                                ? "Release"
                                                : "Hold"
                                            } the Capacity?`}
                                            open={holdOpen}
                                            handleClose={handleHoldClose}
                                            handleCloseNo={handleCloseNo}
                                          />
                                        )}
                                        <button
                                          className="btn btn-withdrawal"
                                          type="button"
                                          onClick={handleWithdraw}
                                        >
                                          Withdraw
                                        </button>
                                        {withdrawOpen && (
                                          <CustomConfirmBox
                                            title="Withdraw"
                                            message="Do you want to withdraw the Capacity?"
                                            open={withdrawOpen}
                                            handleClose={handleWithdrawClose}
                                            handleCloseNo={
                                              handleWithdrawCloseNo
                                            }
                                          />
                                        )}
                                      </div>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};
